export default __webpack_public_path__ + "static/media/download-white.9ba90434.svg";